import { request } from './http';
import type { MediaItem } from './articles';

/**
 * Uploading an image, wherever it is being attached.
 *
 * One endpoint takes them all — it converts and resizes on the way in — so a
 * cover, a chart and a lesson still are the same request. This lives on its
 * own rather than under one of the CRUD clients because a lesson thumbnail
 * going through `articles.upload` reads like a mistake even when it works.
 *
 * Multipart: the browser sets its own boundary, so no Content-Type here.
 */
export const media = {
  upload: (file: File, alt = '') => {
    const form = new FormData();
    form.append('alt', alt);
    form.append('file', file);
    return request<{ media: MediaItem; saved: number }>('/media', { method: 'POST', body: form });
  },
};
